
export interface AppContextType {
  environment: 'production' | 'demo' | 'emulator' | '[unknown]';
  // user?: User;
}

export const environment: AppContextType['environment'] = (() => {
  if (window.location.hostname.startsWith('localhost')) {
    return 'emulator';
  }

  if (window.location.hostname.startsWith('127.0.0.1')) {
    return 'emulator';
  }

  if (window.location.hostname.startsWith('0.0.0.0')) {
    return 'emulator';
  }

  return 'production';
})();